export default {
  "content": "<path fill=\"#6d7276\" d=\"M792.7 262.5l-151.4 71.7v139.4l151.4 71.7V262.5zM203 238.6c-27.9 0-47.8 23.9-47.8 55.8v219.1c0 31.9 19.9 55.8 47.8 55.8h366.5c23.9 0 47.8-23.9 47.8-55.8V294.4c0-31.9-19.9-55.8-47.8-55.8H203z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "viewBox": "0 0 900 800"
  }
};